import request from '@/plugins/axios'

/** 微信第三方平台配置 */
export const apiWxOpenPlatformConfigGet = (): Promise<any> =>
    request.get('/settings.wx_open_platform_setting/getConfig')

export const apiWxOpenPlatformConfigSet = (params: any): Promise<any> =>
    request.post('/settings.wx_open_platform_setting/setConfig', params)
